import axios from 'axios';
import React, { useMemo, useState, useEffect } from 'react';

import { useScreenClass } from 'react-grid-system';
import styled from 'styled-components';
import theme from '../styles/theme';
import Status from '../types/enum/Status';
import Button from './Button';
import FlexBox, { FlexGrow } from './FlexBox';
import Icon, { ClickableIcon } from './Icon';
import Input from './Input';
import Modal from './Modal';
import { Col, Row } from './StyledGridSystem';
import { RightAlign } from './UtilsComponents';

type ScheduleDeleteModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  currentSchedule: { [key: string]: any; };
  courseId: string;
  sectionId: string;
  openParent: any;
  showSections?: boolean;
  // handleDeleteSection: (regId: string) => void
  onDeleteComplete?: () => void
  onDeleteError?: (err: any) => void
}

const wait = async (ms: number) => new Promise((resolve, reject) => {
  setTimeout(resolve, ms);
});

const ScheduleDeleteModal = ({
  isOpen,
  setOpen,
  openParent,
  courseId,
  sectionId,
  currentSchedule,
  // handleDeleteSection,
  onDeleteError,
  onDeleteComplete,
}: ScheduleDeleteModalProps): JSX.Element => {
  const screenClass = useScreenClass();
  const [deleteConfirmation, setDeleteconfirmation] = useState<boolean>(true);
  const [deletePasswordInput, setDeletePasswordInput] = useState<string>('');
  const [isOpenComplete, setOpenComplete] = useState<boolean>(false);
  const [isOpenError, setOpenError] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const handleDeleteSchedule = async (regId: string) => {
    try {
      setLoading(true);
      // alert(`/api/v1/grading/deleteSection?section_reg_id=${regId}`);
      // await wait(800);
      // const res = await axios.delete(`/api/v1/grading/deleteSection?section_reg_id=${regId}`);
      const res = await axios.delete(`/api/v1/courses/${courseId}/sections/${sectionId}/schedule/${regId}`);
      onDeleteComplete?.();
      setOpenComplete(true);
    } catch (err) {
      setOpenError(true);
      console.error(err);
      setError(err);
    }
    setOpen(false);
    setLoading(false);
  };

  const onComplete = () => {
    setOpenComplete(false);
    onDeleteComplete?.();
  };

  const onError = () => {
    setOpenError(false);
    onDeleteError?.(error);
  };

  useEffect(() => {
    if (isOpen) {
      setDeletePasswordInput('');
    }
  }, [isOpen]);

  const deletePassword = useMemo(() => {
    const verb = 'delete';
    return `${verb} ${currentSchedule.day}`;
  }, [currentSchedule]);

  return (
    <>
      <Modal isOpen={isOpen || false} setOpen={setOpen} customStyle={{ overlay: { zIndex: '200' } }}>
        <FlexBox>
          <FlexGrow>
              <h3>Deleting Schedule</h3>
          </FlexGrow>
          <ClickableIcon name='x-s' onClick={() => setOpen(false)} />
        </FlexBox>
        {/* <p style={{ textAlign: 'center' }}>
          <img src="/alert-warning.svg" alt="alert warning"/>
        </p> */}
          <p>
            Are you sure you want to delete the schedule for
            "<b>{currentSchedule.day}</b>"?
            This cannot be undone.
          </p>
        <p>
          To confirm, type "<b>{deletePassword}</b>" in this box.
        </p>
        <Input
          isFullWidth={true}
          value={deletePasswordInput}
          onInput={(e: any) => {
            setDeletePasswordInput(e.target.value);
          }}
        />
        <RightAlign style={{ marginTop: theme.spacing.x2 }}>
          <Button
            isOutline
            onClick={() => {
              setOpen(false);
              // openParent();
            }}
            status={Status.default}>
            Cancel
          </Button>
          <Button
            disabled={isLoading || deletePasswordInput !== deletePassword}
            status={Status.primary}
            onClick={() => handleDeleteSchedule(currentSchedule.id)}
          >
            {isLoading && <>
              <Icon mr={1} name="spinner" spin />
              Deleting...
            </>}
            {!isLoading && <>
              <Icon mr={1} name="trash" />
              Delete section
            </>}
          </Button>
        </RightAlign>
      </Modal>

      <Modal isOpen={isOpenComplete} setOpen={setOpenComplete} onClose={onComplete} customStyle={{ content: { textAlign: 'center' } }}>
        <img src="/alert-success-soft.svg" alt="alert warning" style={{ margin: 'auto' }} />
        <h3>Schedule Deleting Complete</h3>
            <p>
              The schedule "<b>{currentSchedule.day}</b>" has been removed.
            </p>
        <Button status={Status.primary} onClick={onComplete}>Done</Button>
      </Modal>

      <Modal isOpen={isOpenError} setOpen={setOpenError} onClose={onError} customStyle={{ content: { textAlign: 'center' } }}>
        <img src="/alert-warning.svg" alt="alert warning" style={{ margin: 'auto' }} />
        <h3>Schedule Delete Error</h3>
        <p>
          An error occured while deleting the schedule
          "<b>{currentSchedule.day}</b>".
          Please try again or contact us if the problem persists.
        </p>
        <Button status={Status.primary} onClick={onError}>Done</Button>
      </Modal>
    </>
  );
};

export default ScheduleDeleteModal;
